import RoleSelect from '../RoleSelect/RoleSelect';
import SearchAutocomplete from '../Search/SearchAutocomplete';

import './style.scss';

const HeaderStatistics = ({ hidden }) => {
  const style = hidden ? { display: 'none' } : {};

  return (
    <div className="header-item" style={style}>
      <div className="header-item-row">
        <SearchAutocomplete />
        <RoleSelect />
      </div>
    </div>
  );
};

export default HeaderStatistics;
